import type { TintFamily } from '@/components/molecules/status-tokens';
import type { TradeColor } from '@/types/scheduler';

// NOT-329 — map a Trade's palette key to a tile tint family, so job-type coloring
// uses the curated Trade palette (not an arbitrary hash → no rainbow).
const TRADE_FAMILY: Record<TradeColor, TintFamily> = {
  blue: 'blue',
  teal: 'teal',
  amber: 'amber',
  gray: 'gray',
  green: 'emerald',
  coral: 'orange',
  pink: 'pink',
  purple: 'purple',
};

export function tradeColorToFamily(color: TradeColor | null | undefined): TintFamily | undefined {
  return color ? TRADE_FAMILY[color] : undefined;
}
